import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { statusIdZodSchema } from "@@/shared/statuses/status-id";
import { statusReferencesZodObject } from "@@/shared/statuses/status-references";
import { customerIdZodSchema } from "@@/shared/users/customer-id";
import { systemUserZodSchema } from "@@/shared/users/system-user";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";

const _reservationCheckInStatusHistoryZodObject = z.object({
    _id: statusIdZodSchema,
    _type: z.literal("CHECK_IN_STATUS_HISTORY"),
    _createdAt: isoAndUnixZodSchema,
    references: statusReferencesZodObject,
    statuses: z.array(
        z.object({
            setAt: isoAndUnixZodSchema,
            status: z.enum(["CHECKED_OUT", "CHECKED_IN", "PENDING"]),
            setBy: z.union([
                userIdZodSchema,
                customerIdZodSchema,
                systemUserZodSchema,
            ]),
            message: z.string().optional(),
        }),
    ),
});
type ReservationCheckInStatusHistory = z.infer<
    typeof _reservationCheckInStatusHistoryZodObject
>;

type FactoryParams = Except<
    ReservationCheckInStatusHistory,
    "_createdAt" | "_type"
>;
const reservationCheckInStatusHistoryFactory = (
    params: FactoryParams,
): ReservationCheckInStatusHistory => {
    return {
        ...params,
        _type: "CHECK_IN_STATUS_HISTORY",
        _createdAt: nowIsoAndUnix(),
    };
};
export { reservationCheckInStatusHistoryFactory };
export type { ReservationCheckInStatusHistory };
